/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ObjectType {
	Object = 1,
	ObjectType = 2,
}
